"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRADE_PRACTICE_PROBLEM_MODEL = exports.QUESTION_CONTEXT_MODEL = exports.TokenLimit = void 0;
// gpt 3.5 turbo has context limit of 4,096
var TokenLimit;
(function (TokenLimit) {
    TokenLimit[TokenLimit["PROMPT"] = 40] = "PROMPT";
    TokenLimit[TokenLimit["WF_QUESTION"] = 56] = "WF_QUESTION";
    TokenLimit[TokenLimit["CF_CONTEXT"] = 3500] = "CF_CONTEXT";
    TokenLimit[TokenLimit["LLM_RESPONSE"] = 500] = "LLM_RESPONSE";
    TokenLimit[TokenLimit["GRADE_PRACTICE_PROBLEM_QUESTION_SOLUTION_AND_USER_ANSWER"] = 4000] = "GRADE_PRACTICE_PROBLEM_QUESTION_SOLUTION_AND_USER_ANSWER";
})(TokenLimit || (exports.TokenLimit = TokenLimit = {}));
exports.QUESTION_CONTEXT_MODEL = 'gpt-3.5-turbo';
exports.GRADE_PRACTICE_PROBLEM_MODEL = 'gpt-4';
//# sourceMappingURL=limits.js.map